import React from 'react';
import {Button} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import {CustomerComplaint} from '../graphql/types/CustomerComplaintType';

interface Props {
    item: CustomerComplaint;
    /** 右上角 Tag，例如"即将超期" / 历史 tab 状态 Tag。null 表示不渲染 */
    tag?: React.ReactNode;
    /** 标题与运单号之间的信息行，例如处理时效红字 / 下发时间 / 复审时间 */
    infoRow?: React.ReactNode;
    onClick: () => void;
}

const ComplaintCard: React.FC<Props> = ({item, tag, infoRow, onClick}) => {
    const {t} = useTranslation();
    return (
        <div className="bg-white rounded-lg shadow-sm p-3" onClick={onClick}>
            <div className="flex items-start justify-between">
                <div className="font-medium text-base">
                    {t(
                        `pages.dsp.home.customerComplaint.complaintType.${item.complaintType}`,
                        item.complaintType,
                    ) as string}
                </div>
                {tag}
            </div>
            {infoRow && <div className="mt-2">{infoRow}</div>}
            <div className="text-sm mt-1 text-gray-500">
                {t('pages.dsp.home.customerComplaint.list.trackingNumber', '运单号')}:{' '}
                {item.trackingNumber ?? '-'}
            </div>
            {item.orderOverallStatus && (
                <div className="text-sm mt-1 text-gray-500">
                    {t('pages.dsp.home.customerComplaint.list.orderOverallStatus')}:{' '}
                    {t(`common.overallStatus.${item.orderOverallStatus}`, item.orderOverallStatus)}
                </div>
            )}
            <div className="flex justify-end mt-2">
                <Button color="primary" size="small">
                    {t('pages.dsp.home.customerComplaint.list.view')}
                </Button>
            </div>
        </div>
    );
};

export default ComplaintCard;
